import React, { useState } from 'react';
import * as S from './styles';

interface ISliderProps {
  min: number;
  max: number;
  defaultMinValue?: number;
  defaultMaxValue?: number;
  onChange: (values: [number, number]) => void;
}

const Range = ({ min, max, onChange, defaultMinValue, defaultMaxValue }: ISliderProps) => {
  const [displayValOne, setDisplayValOne] = useState(min);
  const [displayValTwo, setDisplayValTwo] = useState(max);

  const handleLowerRangeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(event.target.value);

    if (value <= displayValTwo) {
      setDisplayValOne(value);
      onChange([value, displayValTwo])
    }
  };

  const handleUpperRangeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(event.target.value);
    if (value >= displayValOne) {
      setDisplayValTwo(value);
      onChange([displayValOne, value])
    }

  };

  return (
    <S.Container>
      <div className='inputs'>
        <span id="range1">de R${displayValOne}</span>
        <input
          type="range"
          id="slider-1"
          className="slider-1"
          onChange={handleLowerRangeChange} min="0" max="10000" defaultValue={defaultMinValue} step={displayValOne >= 1000 ? '100' : '20'} />

        <span id="range2">até R${displayValTwo}</span>
        <input
          type="range"
          id="slider-2"
          className="slider-2"
          onChange={handleUpperRangeChange} min="0" max="10000" defaultValue={defaultMaxValue} step={displayValOne >= 1000 ? '100' : '20'} />
      </div>
    </S.Container>
  )
}

export default Range;